import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import IAction from './IAction'

class New extends IAction {
    fn = () => {
        return this.props.onNew
    }
    icon = () => {
        return 'note_add'
    }
    label = () => {
        return i18n.new
    }
    id = () => {
        return 'new_action_navbar'
    }
}

New.propTypes = {
    onNew: PropTypes.func.isRequired,
}

export default New
